import styled from 'styled-components';
import {dFlex, dFlexBetween, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {LIGHT_GRAY, mobileMedia} from '../../../../../../globalVariables/GlobalVariables';

export const footer = styled.div`
    ${dFlexBetween}
    padding: 20px;
    border-top: 1px solid ${LIGHT_GRAY};
    ${mobileMedia}{
        padding: 10px;
    }
`;

export const footerButtons = styled.div`
    ${dFlex}
    gap: 10px;
`;

export const footerCheckbox = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: 8px;
`;
